import React, { Component } from "react";
import CaseEntries from "./CaseEntries/CaseEntries";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
	requestPageOfCases,
	searchData,
	searchSortData
} from "./store/actions";
import "./CaseSelector.css";
import Paginator from "../../hoc/Paginator/Paginator";
import { FaSearch } from "react-icons/fa";

class CaseSelector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
			searchArray: [],
			sortValue: "",
			sortOrder: ""
		};

		this.handleClick = this.handleClick.bind(this);
		this.updateSearchValue = this.updateSearchValue.bind(this);
		this.goToCaseHandler = this.goToCaseHandler.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleClear = this.handleClear.bind(this);
	}

	goToCaseHandler = caseId => {
		sessionStorage.setItem('Type','CASE')
		sessionStorage.setItem('DANDO',false);
		
		const alreadyPurchased = this.props.boughtCases.filter(x => x === caseId).length !== 0;
		if (alreadyPurchased) {
			this.props.history.push("/cases/" + caseId);
		} /*
		if(this.props.firmSettings.subscriber) {
			if (!this.props.firmSettings.subscription) {
				if (alreadyPurchased) {
					this.props.history.push("/cases/" + caseId);
				} else {
					this.props.history.push("/cases/" + caseId + "/purchase");
				}
			} else {
				this.props.history.push("/cases/" + caseId);
			}
		} else {
			if (alreadyPurchased) {
					this.props.history.push("/cases/" + caseId);
				} else {

				}
		}*/
	};

	handleEdit = caseId => {};

	handleSorting = (key, order) => {
		this.setState({ sortValue: key, sortOrder: order });
		let obj = {
			sortValue: key,
			sortOrder: order
		};
		localStorage.setItem("sortParams", JSON.stringify(obj));
		this.props.searchSortData(0, key, order);
	};
	componentDidMount() {
	 
		let page = this.props.currentPage;
		this.props.requestPageOfCases(
			page,
			this.state.sortValue,
			this.state.sortOrder
		);
	 
	}
	updateSearchValue(evt) {
		this.setState({ searchValue: evt.target.value });
	}
	handleClick() {
		localStorage.setItem("searchValue", JSON.stringify(this.state.searchValue));
		sessionStorage.setItem('tempSearchValue',this.state.searchValue)
		var obj = JSON.parse(localStorage.getItem("sortParams"));
		const {sortValue='', sortOrder=''} = obj || {};
		this.setState({ sortValue, sortOrder });
		this.props.searchSortData(0, sortValue, sortOrder);
	}
	handleClear() {
		localStorage.removeItem("sortParams");
		this.setState({sortOrder:'',sortValue:''})
		this.setState({ searchValue: "" });
		localStorage.removeItem("searchValue");
		sessionStorage.removeItem('tempSearchValue')
		
		this.props.searchData(0);
	}

	keyPress(e) {
		if (e.keyCode === 13 || e.keyCode === 10) {
			this.handleClick();
		}
	}

	componentDidUpdate(){
	window.onpopstate  = (e) => {
		e.preventDefault();
		var tempSearchValue = sessionStorage.getItem('tempSearchValue')

		if(tempSearchValue){
			setTimeout(()=>{
				localStorage.setItem("searchValue", JSON.stringify(tempSearchValue));
				this.props.searchData(this.props.currentPage);
			 },100)
			
			 this.setState({ searchValue: tempSearchValue })
			 
		}
		 var obj = JSON.parse(localStorage.getItem("sortParams"));
		 if(obj){
		 this.setState({
		 sortValue:obj.sortValue,
		 sortOrder:obj.sortOrder
		 })
	 setTimeout(()=>{
		this.props.searchSortData(this.props.currentPage, obj.sortValue, obj.sortOrder);
	 },200) 
	
		}
	 }
	}


	render() {
	
	return (
		<React.Fragment>
		
		<div
			style={{ display: "flex", justifyContent: "space-between" }}
			className={"CaseSelectorTitle"}
		>
			<span>SCA Database</span>
			<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				width: "180"
			}}
			>
			<div
				style={{
				position: "relative",
				width: "207px",
				height: "29px",
				top: "-1px",
				backgroundColor: "#83bed3",
				border: "1px solid rgb(90, 154, 176)",
				borderRadius: "14.5px"
				}}
			>
				<input
				id="search"
				type="text"
				className="searchBox"
				onKeyDown={e => this.keyPress(e)}
				value={this.state.searchValue}
				placeholder="Search"
				onChange={this.updateSearchValue}
				/>
				{this.state.searchValue && (
				<span className="clearIcon" onClick={this.handleClear}>
					x
				</span>
				)}
				<FaSearch className="searchBtn" onClick={this.handleClick} />
			</div>
			</div>
		</div>
		{this.props.currentCases.length > 0 ? (
			<CaseEntries
			allProps={this.props}
			cases={this.props.currentCases}
			sortValue={this.state.sortValue}
			sortOrder={this.state.sortOrder}
			goToCaseHandler={this.goToCaseHandler}
			handleEdit={this.handleEdit}
			handleSorting={this.handleSorting}
			/>
		) : (
			<div className="widthfull">
			<table className="widthfull">
				<tbody>
				<tr>
					<td className="norecords">
					<span>No Records Found</span>
					</td>
				</tr>
				</tbody>
			</table>
			</div>
		)}
		{this.props.currentCases.length > 0 ? (
			<Paginator
			name={"case-selector"}
			totalPages={this.props.totalPages}
			currentPage={this.props.currentPage}
			setPage={(pageNumber) =>this.props.requestPageOfCases(pageNumber, this.state.sortValue, this.state.sortOrder)}
			/>
		) : (
			""
		)}
		 <div className={"purchase-text"}>
			<table className="widthfull">
				<tbody>
				<tr>
					<td className="purchase-body">
					<div className={"purchase-section"}><u>Source Data Disclosure</u>:  SAR, LLC (“SAR”) relies on raw data from qualified financial and legal data suppliers (our “Data Partners”) to perform independent event study analyses to evaluate price impact and attain a maximum estimate of potentially available aggregate damages for alleged violations of the federal securities laws under Section 10(b) and 20(a) of the Securities Exchange Act of 1934 (the “Exchange Act”) and Rule 10b-5 promulgated thereunder by the U.S. Securities and Exchange Commission.  SAR relies on raw data from our Data Partners to identify adverse events of U.S.-listed Corporations and quantify the embedded securities class action risk via the SCA Risk Tool. Financial raw data is sourced by S&P Global Market Intelligence. Legal notifications of case filings are provided and sourced by SL Court Wire and Docket Tracking alerts of Westlaw PRO&trade;, a product of West Publishing Corporation, a Thomson Reuters Company. SAR attains legal complaints, motions and court opinions via the General Counsel Essentials Westlaw product of West Publishing Corporation, a Thomson Reuters Company.  SAR attains case settlement data as sourced by ISS Securities Class Action Services (SCAS).</div>
					</td>
				</tr>
				</tbody>
			</table>
			</div>
		</React.Fragment>
	);
	}
}

const mapStateToProps = state => {
	return {
	currentCases: state.cases.currentCases,
	currentPage: state.cases.currentPage,
	totalCases: state.cases.totalCases,
	totalPages: state.cases.totalPages,
	firmSettings: state.firmSettings,
	boughtCases: state.ownedCases.boughtCases
	};
};

const mapDispatchToProps = dispatch => {
	return {
	requestPageOfCases: (page, sortValue, sortOrder) =>
		dispatch(requestPageOfCases(page, sortValue, sortOrder)),
	searchData: page => dispatch(searchData(page)),
	searchSortData: (currentPage, sortValue, sortOrder) =>
		dispatch(searchSortData(currentPage, sortValue, sortOrder))
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(CaseSelector));



// WEBPACK FOOTER //
// ./src/components/CaseSelector/CaseSelector.js